import React from 'react';
import PropTypes from 'prop-types';
import SettingsMenu from './Components/SettingsMenuView';
import { FirmSettings } from '../AdviserSettingsOPL/tabs/FirmSettings/FirmSettings';
import { MySettings } from '../AdviserSettingsOPL/tabs/MySettings/MySettings';
import { DataFeedsSettings } from '../AdviserSettingsOPL/tabs/DataFeedsSettings/DataFeedsSettings';
import { Integrations } from '../AdviserSettingsOPL/tabs/Integrations/Integrations';
import AssetClasses from './Page/AssetClasses/AssetClassesContainer';
import { Models } from './Page/Models/Models';
import CustomModelAssumptions from './Page/CustomModelAssumptions';
import { AssetBucketing } from '../AdviserSettingsOPL/tabs/AssetBucketing/AssetBucketing';
import { Text } from '../CommonComponents/OPL/Text/Text';
import { Box } from '../CommonComponents/OPL/Box/Box';
import {
  MENU_OPTIONS,
  MY_SETTINGS_OPTION,
  FIRM_SETTINGS_OPTION,
  INTEGRATIONS_OPTION,
  MODELS_OPTION,
  ASSET_CLASSES,
  CUSTOM_MODEL_ASSUMPTIONS,
  ASSET_BUCKETING,
  DATA_FEEDS_SETTINGS_OPTION,
} from './AdviserSettingsConst';
import { useDocumentTitle } from '../_hooks/useDocumentTitle';

const COMPONENTS_DICTIONARY = {
  [MY_SETTINGS_OPTION]: MySettings,
  [FIRM_SETTINGS_OPTION]: FirmSettings,
  [INTEGRATIONS_OPTION]: Integrations,
  [MODELS_OPTION]: Models,
  [ASSET_CLASSES]: AssetClasses,
  [CUSTOM_MODEL_ASSUMPTIONS]: CustomModelAssumptions,
  [ASSET_BUCKETING]: AssetBucketing,
  [DATA_FEEDS_SETTINGS_OPTION]: DataFeedsSettings,
};

export const pageId = page => {
  const properties = MENU_OPTIONS.find(
    ({ slug }) => slug.toLocaleLowerCase() === page.toLocaleLowerCase(),
  );

  return properties.id;
};

const AdviserSettings = ({
  showAssetClassMapping,
  firmSettingsAccess,
  currentRoute: {
    params: { page },
  },
  showFinancialPlanning,
  hasAssetBucketingFirm,
  dataFeedsUrl,
}) => {
  const currentPageId = pageId(page);

  const SettingsPage = COMPONENTS_DICTIONARY[currentPageId];

  useDocumentTitle('Settings');

  return (
    <Box display="flex" flexDirection="column" height="100%">
      <Text as="h1" fontWeight={600} color="neutral.600" fontSize="h3">
        Application Settings
      </Text>
      <SettingsMenu
        currentPageId={currentPageId}
        firmSettingsAccess={firmSettingsAccess}
        showAssetClassMapping={showAssetClassMapping}
        showFinancialPlanning={showFinancialPlanning}
        hasAssetBucketingFirm={hasAssetBucketingFirm}
        dataFeedsUrl={dataFeedsUrl}
      >
        <SettingsPage />
      </SettingsMenu>
    </Box>
  );
};

AdviserSettings.propTypes = {
  showAssetClassMapping: PropTypes.bool.isRequired,
  firmSettingsAccess: PropTypes.bool.isRequired,
  currentRoute: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
    }),
  }).isRequired,
  showFinancialPlanning: PropTypes.bool.isRequired,
  hasAssetBucketingFirm: PropTypes.bool.isRequired,
  dataFeedsUrl: PropTypes.oneOfType([PropTypes.string, PropTypes.oneOf([null])]).isRequired,
};

export default AdviserSettings;
